export const logError = (e: Error | unknown, title: string) => {
  const errorMessage = e instanceof Error ? e.message : JSON.stringify(e)
  console.error(`${title}: ${errorMessage}`)
}
